const { trackGtm, trackGtm4 } = require('util/functions');

module.exports = {
	init() {
		const links = this.root.querySelectorAll(
			'a:not(.small-image-above-title--picture)',
		);
		const imageLinks = this.root.querySelectorAll(
			'.small-image-above-title--picture',
		);
		const widgetName = this.root.getAttribute('data-parent');
		const widgetTitle = this.root.getAttribute('data-parent-title');
		const widgetSubTitle = this.root.getAttribute('data-parent-title');
		const innerTitle = this.root
			.closest('.related-articles-partial')
			?.querySelector('.related-articles-partial--title').innerText;

		const parentTitle = widgetTitle ? widgetTitle : widgetSubTitle;
		const childTitle = innerTitle ? innerTitle : 'No title: title not set';
		links.forEach(link => {
			link.addEventListener('click', () => {
				trackGtm({
					eventCategory: 'cta',
					eventAction: 'title',
					eventLabel: `${link.textContent} / ${link.href}`,
				});
				trackGtm4({
					event: 'GA4_event_c_cta',
					widget_name: widgetName ? widgetName : 'V3-Article highlight',
					widget_title: parentTitle ? parentTitle : childTitle,
					link_text: link.textContent,
					link_url: link.href,
					button_type: '',
				});
			});
		});
		imageLinks.forEach(imageLink => {
			imageLink.addEventListener('click', event => {
				trackGtm4({
					event: 'GA4_event_c_cta',
					widget_name: widgetName ? widgetName : 'V3-Article highlight',
					widget_title: parentTitle ? parentTitle : childTitle,
					link_text: `Image alt text: ${event.target.alt}`,
					link_url: imageLink.closest('.small-image-above-title--picture').href,
					button_type: '',
				});
			});
		});
	},
};
